const accessibilityToggle = document.getElementById("accessibility-toggle");
const accessibilityToggleMobile = document.getElementById("accessibility-toggle-mobile");
const accessibilityClose = document.getElementById("accessibility-close");
const accessibilityPopup = document.getElementById("accessibility-popup");
const highContrastButton = document.getElementById("toggle-high-contrast");
const largeTextButton = document.getElementById("toggle-large-text");

function LumiSetCookie(name, value, days) {
  const expires = days
    ? "; expires=" + new Date(Date.now() + days * 864e5).toUTCString()
    : "";
  document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function LumiGetCookie(name) {
  const value = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return value ? decodeURIComponent(value.pop()) : null;
}

function LumiDeleteCookie(name) {
  LumiSetCookie(name, "", -1);
}

document.addEventListener("DOMContentLoaded", () => {
  // Toggle popup visibility
  accessibilityToggle.addEventListener("click", (e) => {
    e.stopPropagation(); // Prevent click from reaching the document
    accessibilityPopup.classList.toggle("hidden");
  });
  accessibilityToggleMobile.addEventListener("click", (e) => {
    e.stopPropagation(); // Prevent click from reaching the document
    accessibilityPopup.classList.toggle("hidden");
  });
  accessibilityClose.addEventListener("click", (e) => {
    e.stopPropagation(); // Prevent click from reaching the document
    accessibilityPopup.classList.toggle("hidden");
  });

  // Close popup when clicking outside
  document.addEventListener("click", (e) => {
    if (
      !accessibilityPopup.contains(e.target) &&
      e.target !== accessibilityToggle
    ) {
      accessibilityPopup.classList.add("hidden");
    }
  });

  // Optional: Close popup on Escape key press
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      accessibilityPopup.classList.add("hidden");
    }
  });
});

// Apply preferences on load
if (LumiGetCookie("highContrast") === "1") {
  document.documentElement.classList.add("high-contrast");
}

if (LumiGetCookie("largeText") === "1") {
  document.documentElement.classList.add("large-text");
}

// Update localStorage when toggles are clicked
highContrastButton.addEventListener("click", () => {
  const enabled = document.documentElement.classList.toggle("high-contrast");
  LumiSetCookie("highContrast", enabled ? "1" : "0", 365); // expires in 1 year
});

// Toggle large text
largeTextButton.addEventListener("click", () => {
  const enabled = document.documentElement.classList.toggle("large-text");
  LumiSetCookie("largeText", enabled ? "1" : "0", 365); // expires in 1 year
});